import { getRouteApi, HeadContent, Scripts } from '@tanstack/react-router';
import { ChevronLeft, ChevronRight, TriangleAlert } from 'lucide-react';
import { ReactNode } from 'react';
import { cn } from '~/util';
import { useSettingsStore } from '~/util/stores/settings';

const Route = getRouteApi('__root__');
export function RootDocument({ children }: Readonly<{ children: ReactNode }>) {
    const { opened_dev_preview_warning, setOpenedDevPreviewWarning } =
        useSettingsStore();
    const cssVariables = Route.useLoaderData({
        select: ({ cssVariables }) => cssVariables,
    });
    return (
        <html lang="en">
            <head>
                <HeadContent />
                <style dangerouslySetInnerHTML={{ __html: cssVariables }} />
            </head>
            <body>
                {import.meta.env.VITE_DEV_PREVIEW ? (
                    <div
                        className={cn(
                            'fixed left-0 bottom-4 z-30 max-w-[min(92vw,38rem)] transition-transform duration-300 ease-in-out',
                            opened_dev_preview_warning
                                ? 'translate-x-0'
                                : '-translate-x-[calc(100%-2.25rem)]',
                        )}
                    >
                        <div className="relative flex items-start gap-2 rounded-r-lg border border-primary/30 bg-primary px-3 py-2 text-primary-foreground shadow-lg">
                            <TriangleAlert
                                className="mt-0.5 shrink-0"
                                height={24}
                                width={24}
                            />
                            <p className="text-sm leading-tight pr-10">
                                You are currently on the
                                <strong> development preview </strong> website.
                                Data might not be accurate.
                                <strong>
                                    {' '}
                                    No changes made here will be saved{' '}
                                </strong>
                                to the public website.
                            </p>
                            <button
                                type="button"
                                onClick={() =>
                                    setOpenedDevPreviewWarning(
                                        !opened_dev_preview_warning,
                                    )
                                }
                                aria-label={
                                    opened_dev_preview_warning
                                        ? 'Close development preview warning'
                                        : 'Open development preview warning'
                                }
                                aria-expanded={opened_dev_preview_warning}
                                className="absolute right-0 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-md border border-primary-foreground bg-primary text-primary-foreground hover:brightness-90 cursor-pointer"
                            >
                                {opened_dev_preview_warning ? (
                                    <ChevronLeft size={18} />
                                ) : (
                                    <ChevronRight size={18} />
                                )}
                            </button>
                        </div>
                    </div>
                ) : null}
                {children}
                <Scripts />
            </body>
        </html>
    );
}
